<template>
  <div class="chart-config" :class="show && 'is-show'">
    <div class="expand-btn" @click="$emit('showChartConfig')">
      <i class="el-icon-arrow-right" v-show="show"></i>
      <i class="el-icon-arrow-left" v-show="!show"></i>
    </div>
    <div class="chart-config-tabs">
      <div
        class="chart-config-tab-item"
        :class="tabActive === 'chartTab' && 'is-active'"
        @click="tabActive = 'chartTab'"
      >
        <span>推荐图表</span>
      </div>
      <div
        class="chart-config-tab-item"
        :class="tabActive === 'settingTab' && 'is-active'"
        @click="tabActive = 'settingTab'"
      >
        <span>图表设置</span>
      </div>
    </div>
    <el-collapse v-model="chartCollapseActive" v-show="tabActive === 'chartTab'">
      <el-collapse-item name="chartTypeConfig">
        <span slot="title" class="title-name"
          ><span class="icon-smaller"><i class="iconfont icontubiaoleixing"></i></span>图表类型</span
        >
        <div class="chart-type-list">
          <div
            v-for="(chartItem, chartIndex) in chartArr"
            :key="chartIndex"
            class="chart-type-list-item"
            :class="[
              chartType === chartItem.type ? 'is-pick' : '',
              effChartArr.includes(chartItem.type) ? '' : 'is-disabled'
            ]"
            @click="changeChartTypeHandle(chartItem.type)"
          >
            <el-popover placement="top-start" trigger="hover">
              <div slot="reference" class="mask"></div>
              <div class="chart-detail-info">
                <div class="chart-title">{{ chartItem.name }}</div>
                <div class="chart-tip-ul" v-if="false && (chartItem.tips || []).length > 0">
                  <div class="chart-tip-li" v-for="(tipItem, tipIndex) in chartItem.tips" :key="tipIndex">
                    <span v-html="formatTipHandle(tipItem)"></span>
                  </div>
                </div>
              </div>
            </el-popover>
            <img class="preview-img" :src="chartImg[`${chartItem.type}Img`]" />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-model="settingCollapseActive" v-show="tabActive === 'settingTab'">
      <el-collapse-item name="fieldSize">
        <span slot="title" class="title-name">
          <span class="icon-smaller"><i class="iconfont iconwenbenshezhi"></i></span>
          <span v-if="chartType === 'barXChart'">Y轴标签数设置</span>
          <span v-else>X轴标签数设置</span>
          <span class="field-size-tip">(默认显示10个)</span>
        </span>
        <el-form @submit.native.prevent class="form-container" label-width="80px" label-position="left">
          <template v-for="(fieldItem, fieldIndex) in fieldsArr">
            <el-form-item v-if="fieldShowHandle(fieldItem)" :key="fieldItem.columnKey" :label="fieldItem.title">
              <el-input-number
                class="input-item"
                @change="changSizeHandle"
                v-model="fieldSizeArr[fieldIndex]"
                size="small"
                :precision="0"
                :min="1"
                :max="200"
              />
            </el-form-item>
          </template>
        </el-form>
      </el-collapse-item>

      <el-collapse-item name="chartConfig" v-if="isEchart">
        <span slot="title" class="title-name">
          <span class="icon-smaller"><i class="iconfont iconshezhi"></i></span>图表设置</span
        >
        <el-form @submit.native.prevent class="form-container" label-width="90px" label-position="left">
          <el-form-item label="字体大小">
            <el-input-number
              class="input-item"
              placeholder="12"
              v-model="chartConfig.fontSize"
              :precision="0"
              :min="12"
              :max="24"
            />
          </el-form-item>
          <div v-show="showXYConfig">
            <el-form-item :label="chartType === 'barXChart' ? 'y轴单位' : 'x轴单位'">
              <el-input
                class="input-item"
                :maxlength="6"
                :placeholder="defaultChartConfigTemp.xName || '请输入'"
                v-model="chartConfig.xName"
              ></el-input>
            </el-form-item>
            <el-form-item :label="chartType === 'barXChart' ? 'y轴单位标签' : 'x轴单位标签'">
              <el-input
                class="input-item"
                :maxlength="3"
                :placeholder="'请输入'"
                v-model="chartConfig.xUnit"
              ></el-input>
            </el-form-item>
            <el-form-item :label="chartType === 'barXChart' ? 'x轴单位' : 'y轴单位'">
              <el-input
                class="input-item"
                :maxlength="6"
                :placeholder="fetchYNamePlaceholder(defaultChartConfigTemp.yNameArr) || '请输入'"
                v-model="chartConfig.yName"
              ></el-input>
            </el-form-item>
            <el-form-item :label="chartType === 'barXChart' ? 'x轴单位标签' : 'y轴单位标签'">
              <el-input
                class="input-item"
                :maxlength="3"
                :placeholder="'请输入'"
                v-model="chartConfig.yUnit"
              ></el-input>
            </el-form-item>
            <el-form-item label="左侧间距">
              <el-input-number
                class="input-item"
                :placeholder="defaultChartConfigTemp.left || '请输入'"
                v-model="chartConfig.left"
                :precision="0"
              />
            </el-form-item>
            <el-form-item label="右侧间距">
              <el-input-number
                class="input-item"
                :placeholder="defaultChartConfigTemp.right || '请输入'"
                v-model="chartConfig.right"
                :precision="0"
              />
            </el-form-item>
            <el-form-item label="底部间距">
              <el-input-number
                class="input-item"
                :placeholder="defaultChartConfigTemp.bottom || '请输入'"
                v-model="chartConfig.bottom"
                :precision="0"
              />
            </el-form-item>
            <el-form-item label="文字倾斜度">
              <el-input-number
                class="input-item"
                :placeholder="defaultChartConfigTemp.rotate || '请输入'"
                v-model="chartConfig.rotate"
                :precision="0"
              />
            </el-form-item>
            <el-form-item label="文字显示数">
              <el-input-number
                class="input-item"
                :placeholder="defaultChartConfigTemp.textEllipsis || '请输入'"
                v-model="chartConfig.textEllipsis"
                :min="1"
                :precision="0"
              />
            </el-form-item>
          </div>
        </el-form>
      </el-collapse-item>

      <el-collapse-item name="themeConfig" v-if="isEchart">
        <span slot="title" class="title-name">
          <span class="icon-smaller"><i class="iconfont iconyansezhuti"></i></span>颜色主题</span
        >
        <el-form @submit.native.prevent class="form-container" label-width="90px" label-position="left">
          <el-form-item label="颜色主题">
            <el-dropdown trigger="click" @command="idx => (colors = [...chartThemeColors[idx]])">
              <div class="chart-theme-color-select">
                <div
                  class="chart-theme-color-item"
                  v-for="color in chartThemeColors[0]"
                  :key="color.slice(1)"
                  :style="{ background: color }"
                ></div>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(colorArr, colorGroupIdx) in chartThemeColors"
                  :key="colorGroupIdx"
                  :command="colorGroupIdx"
                  :style="{ height: '20px' }"
                >
                  <div
                    v-for="(color, colorIdx) in colorArr"
                    :key="`${colorGroupIdx}_${color.slice(1)}_${colorIdx}`"
                    :style="{ display: 'inline-block', width: '18px', height: '12px', background: color }"
                  ></div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="编辑颜色">
            <div class="chart-theme-color-select" :style="{ lineHeight: '20px' }">
              <el-popover
                placement="bottom-end"
                title=""
                width="224"
                v-for="(color, colorIdx) in colors"
                :key="colorIdx"
                trigger="manual"
                :value="colorPickerModal.visible && colorPickerModal.idx === colorIdx"
              >
                <div
                  slot="reference"
                  class="chart-theme-color-item"
                  :style="{ width: '18px', marginRight: '6px', background: color }"
                  @click="colorPickerModal.init(colors, colorIdx)"
                ></div>
                <div :style="{ padding: '2px' }">
                  <colorPicker
                    :style="{ boxShadow: 'none' }"
                    :value="colorPickerModal.color"
                    @input="changeColorHandle"
                  />
                </div>
              </el-popover>
            </div>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { Sketch as colorPicker } from 'vue-color';

import lineChartImg from '@/assets/img/chartPreview/lineChart.png';
import lineChart2Img from '@/assets/img/chartPreview/lineChart2.png';
import barChartImg from '@/assets/img/chartPreview/barChart.png';
import barXChartImg from '@/assets/img/chartPreview/barXChart.png';
import pieChartImg from '@/assets/img/chartPreview/pieChart.png';
import pieChart2Img from '@/assets/img/chartPreview/pieChart2.png';
import numChartImg from '@/assets/img/chartPreview/numChart.png';
import tableChartImg from '@/assets/img/chartPreview/tableChart.png';

import { chartDefaultConfig } from '@/constantEnum';
import { chartThemeColors } from '@/constant';
import { debounce } from 'lodash';

export default {
  components: { colorPicker },
  data() {
    return {
      tabActive: 'chartTab',
      chartCollapseActive: ['chartTypeConfig'],
      settingCollapseActive: ['fieldSize', 'chartConfig', 'themeConfig'],
      chartImg: {
        lineChartImg,
        lineChart2Img,
        barChartImg,
        barXChartImg,
        pieChartImg,
        pieChart2Img,
        numChartImg,
        tableChartImg
      },
      chartType: '',
      chartConfig: null,
      chartThemeColors,
      colors: [],
      chartArr: [
        { name: '柱状图', type: 'barChart', tips: ['1个标签，n个统计值', '2个标签，1个统计值'] },
        { name: '条形图', type: 'barXChart', tips: ['1个标签，n个统计值', '2个标签，1个统计值'] },
        { name: '折线图', type: 'lineChart2', tips: ['1个标签，n个统计值', '2个标签，1个统计值'] },
        { name: '折线图', type: 'lineChart', tips: ['1个标签，n个统计值', '2个标签，1个统计值'] },
        { name: '饼图', type: 'pieChart', tips: ['1个标签，1个统计值'] },
        { name: '环形图', type: 'pieChart2', tips: ['1个标签，1个统计值'] },
        { name: '数值', type: 'numChart', tips: ['0个标签，1个统计值'] },
        { name: '表格', type: 'tableChart' }
      ],
      fieldSizeArr: [],
      colorPickerModal: {
        visible: false,
        idx: -1,
        color: '',
        init: function(colors, index) {
          this.tapContent = true;

          if (this.visible && this.idx === index) {
            this.visible = false;
            return;
          }
          this.idx = index;
          this.color = colors[index];
          this.visible = true;
        }
      }
    };
  },
  props: {
    chartDetail: {
      type: Object,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    statistics: {
      type: Array,
      required: true
    },
    defaultChartConfig: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isEchart() {
      return ['barChart', 'barXChart', 'lineChart2', 'lineChart', 'pieChart', 'pieChart2'].includes(this.chartType);
    },
    fieldsArr() {
      return [...this.rows, ...this.columns];
    },
    showXYConfig() {
      return ['barChart', 'barXChart', 'lineChart2', 'lineChart'].includes(this.chartType);
    },
    effChartArr() {
      const rowCount = this.rows.length;
      const statisticsCount = [...this.statistics, ...this.columns].length;
      if (rowCount >= 3) {
        return ['tableChart'];
      }

      if (rowCount === 2) {
        if (statisticsCount > 1) {
          return ['tableChart'];
        }
        return ['barChart', 'barXChart', 'lineChart2', 'lineChart', 'tableChart'];
      }

      if (rowCount === 1) {
        if (statisticsCount > 1) {
          return ['barChart', 'barXChart', 'lineChart2', 'lineChart', 'tableChart'];
        }
        return ['barChart', 'barXChart', 'lineChart2', 'lineChart', 'pieChart', 'pieChart2', 'tableChart'];
      }

      const allTypeArr = this.chartArr.map(item => item.type);

      if (
        rowCount !== 0 ||
        statisticsCount > 1 ||
        (rowCount === 0 && statisticsCount === 1 && !this.statistics[0].fieldDetail.isDefaultStatistic)
      ) {
        return allTypeArr.filter(type => type !== 'numChart');
      }

      return allTypeArr;
    },
    defaultChartConfigTemp() {
      const temp = {};
      Object.keys(this.defaultChartConfig).forEach(key => {
        const val = this.defaultChartConfig[key];
        if (isNaN(val)) {
          temp[key] = val || '';
        } else {
          temp[key] = String(val);
        }
      });
      return temp;
    }
  },
  watch: {
    chartType(val, oldVal) {
      if (!oldVal) {
        return;
      }
      // 修改类型时候需要重置图表配置
      this.chartConfig = { ...(chartDefaultConfig[val] || {}) };
    },
    chartConfig: {
      handler(val, oldVal) {
        if (!oldVal) {
          return;
        }
        this.changeChartHandle();
      },
      deep: true
    },
    colors() {
      this.changeChartHandle();
    },
    fieldsArr: {
      handler(val) {
        this.fieldSizeArr = val.map(fieldItem => fieldItem.size || 10);
      },
      immediate: true
    }
  },
  beforeDestroy() {
    window.removeEventListener('click', this.tapListener);
  },
  created() {
    window.addEventListener('click', this.tapListener);
    this.$emit('initApis', {
      changeTypeHandle: type => this.changeChartTypeHandle(type),
      fetchEffChartArr: () => this.effChartArr
    });
    this.chartType = this.chartDetail.type;
    this.colors = [...(this.chartDetail.colors || [])];
    this.chartConfig = { ...(chartDefaultConfig[this.chartType] || {}), ...(this.chartDetail.chartConfig || {}) };

    // 添加防抖，watch可能会链式调用导致多次触发
    this.changeChartHandle = debounce(this.changeChartHandle.bind(this), 200);
  },
  methods: {
    tapListener() {
      const tapContent = this.colorPickerModal.tapContent;
      this.colorPickerModal.tapContent = false;
      if (tapContent) {
        return;
      }
      this.colorPickerModal.visible = false;
    },
    changeColorHandle({ hex }) {
      this.colorPickerModal.color = hex;
      this.colors.splice(this.colorPickerModal.idx, 1, this.colorPickerModal.color);
    },
    fieldShowHandle(item) {
      if (['text', 'date'].includes(item.type)) {
        return true;
      }
      if (item.type === 'num') {
        const valueOfFilter = JSON.parse(item.valueOfFilter || '{}');
        if (valueOfFilter.type === 'noRange') {
          return true;
        }
      }
      return false;
    },
    showCollapse(type) {
      if (['chartTypeConfig'].includes(type)) {
        this.tabActive = 'chartTab';
        if (!this.chartCollapseActive.includes(type)) {
          this.chartCollapseActive.push(type);
        }
      }

      if (['fieldSize', 'chartConfig', 'themeConfig'].includes(type)) {
        this.tabActive = 'settingTab';
        if (!this.settingCollapseActive.includes(type)) {
          this.settingCollapseActive.push(type);
        }
      }
    },
    fetchYNamePlaceholder(yNameArr) {
      if ((yNameArr || []).length > 0) {
        return yNameArr[0];
      }
      return '';
    },
    formatTipHandle(tipText) {
      return tipText.replace(/\d/g, function(val) {
        return `<span style="color: #1991fb;">${val}</span>`;
      });
    },
    changeChartTypeHandle(type) {
      if (this.effChartArr.includes(type)) {
        this.chartType = type;
      }
    },
    changeChartHandle() {
      this.$emit('changeChartConfigHandle', {
        type: this.chartType,
        chartConfigStr: JSON.stringify(this.chartConfig || {}),
        colors: this.colors
      });
    },
    changSizeHandle() {
      const rowSizeArr = this.rows.map((rowItem, rowIndex) => {
        return this.fieldSizeArr[rowIndex] || 10;
      });
      const columnSizeArr = this.columns.map((columnItem, columnIndex) => {
        return this.fieldSizeArr[columnIndex + this.rows.length];
      });
      this.$emit('changeFieldSizeHandle', { rowSizeArr, columnSizeArr });
    }
  }
};
</script>
<style lang="scss" scoped>
.chart-detail-info {
  padding: 10px;
  .chart-title {
    font-size: 12px;
  }

  .chart-tip-ul {
    margin-top: 4px;

    .chart-tip-li {
      font-size: 12px;
      line-height: 20px;
    }
  }
}
.chart-config {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 280px;
  margin-right: -280px;
  border-left: 1px solid #d9dde4;
  display: flex;
  flex-direction: column;

  .expand-btn {
    position: absolute;
    top: 35px;
    left: -35px;
    background-color: #fff;
    box-shadow: 0px 0px 6px 2px rgba(48, 57, 69, 0.2);
    padding: 3px 5px;
    cursor: pointer;
    z-index: 12;
    border-radius: 50%;

    & > i {
      font-size: 12px;
    }

    &:hover {
      color: #fff;
      background-color: rgba(#1991fb, 0.8);
      border-color: #1991fb;
    }
  }

  &.is-show {
    margin-right: 0;

    .expand-btn {
      opacity: 0;
      left: -15px;
    }

    &:hover {
      .expand-btn {
        opacity: 1;
      }
    }
  }

  .chart-config-tabs {
    display: flex;
    width: 100%;
    height: 49px;
    background-color: #fff;

    .chart-config-tab-item {
      position: relative;
      flex: 1;
      height: 100%;
      font-size: 14px;
      color: #3d465a;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      & > span {
        font-weight: inherit;
      }

      &::before {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #1991fb;
        display: none;
      }

      &:first-child {
        &::after {
          content: ' ';
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          height: 24px;
          width: 1px;
          background-color: #e8ebef;
        }
      }

      &.is-active {
        color: #1991fb;
        font-weight: bold;

        &::before {
          display: block;
        }
      }
    }
  }

  ::v-deep .el-collapse {
    flex: 1;
    height: 0;
    width: 100%;
    overflow: auto;
    background-color: #f9fbff;

    &::-webkit-scrollbar {
      display: none;
    }

    .el-collapse-item {
      margin-top: 10px;

      .el-collapse-item__header {
        border-top: 1px solid #ebeef5;
        &.is-active {
          border-bottom-color: transparent;
        }
      }

      .el-collapse-item__content {
        background-color: #fff;
        .el-form-item__label {
          color: #3d465a;
        }
      }

      &:first-child {
        margin-top: 0;

        .el-collapse-item__header {
          border-top: 0;
        }
      }
    }
  }

  .title-name {
    padding-left: 15px;
    color: #2c3443;
    font-size: 13px;
    .icon-smaller {
      margin-right: 8px;
    }

    .field-size-tip {
      color: #9599a5;
      font-size: 12px;
    }
  }

  ::v-deep .form-container {
    padding: 0px 10px 1px;

    &.el-form {
      .el-form-item {
        margin-bottom: 10px;
      }
    }

    .chart-theme-color-select {
      .chart-theme-color-item {
        display: inline-block;
        width: 14px;
        height: 12px;
        background-color: #fff;
        cursor: pointer;
      }
      .el-icon-arrow-down {
        position: relative;
        top: -1px;
      }
    }

    .input-item {
      width: 150px;

      .el-input-number__decrease,
      .el-input-number__increase {
        height: 25px;
        margin-top: 2px;
      }

      .el-input__inner {
        height: 28px;
        line-height: 26px;
      }
    }
  }

  .help-content {
    box-sizing: border-box;
    padding: 15px 10px;
    max-height: 600px;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #f9fbff;
  }

  .chart-type-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: #f9fbff;
    padding: 15px 10px 5px;
    &-item {
      box-sizing: border-box;
      position: relative;
      width: calc(50% - 5px);
      padding-bottom: 25%;
      margin-bottom: 10px;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
      border: 1px solid #f9fbff;

      .mask {
        position: absolute;
        top: 0%;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 2;
        transition: opacity 0.4s;
        opacity: 0;
      }

      .preview-img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &.is-pick {
        border: 1px solid #0c93f2;
      }

      &.big-item {
        width: 80%;
        margin: 0 auto 10px;
        padding-bottom: 40%;
      }

      &.is-disabled {
        cursor: not-allowed;
        border: 0 !important;

        .mask {
          opacity: 1;
        }
      }

      &:hover {
        border-color: #0c93f2;
      }
    }
  }
}
</style>
